"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterSelector = void 0;
const react_1 = __importStar(require("react"));
const controls_1 = require("./..");
const FilterMenu_1 = require("../../FilterMenu");
const helpers_1 = require("../../helpers");
exports.FilterSelector = (0, helpers_1.createUIElement)('FilterSelector', (_a, ref) => {
    var { className, placeholder = 'Not chosen...', error, disabled, renderMenu, renderValueText, renderIconBefore, renderIconAfter, size, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "placeholder", "error", "disabled", "renderMenu", "renderValueText", "renderIconBefore", "renderIconAfter", "size", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const rootRef = (0, react_1.useRef)(null);
    const buttonRef = ref || rootRef;
    const valueText = (0, react_1.useMemo)(() => (renderValueText === null || renderValueText === void 0 ? void 0 : renderValueText()) || placeholder, [placeholder, renderValueText]);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'filter-selector', [initialDataSelectorId]);
    const [control] = (0, controls_1.useDropdown)({
        ref: buttonRef,
        renderControl: ({ button, isActive, actions }) => {
            var _a, _b;
            return (react_1.default.createElement(controls_1.SelectButton, Object.assign({}, rest, { ref: buttonRef, style: style, "data-selector-id": dataSelectorId, active: isActive, onKeyDownActivate: () => actions.show(), disabled: disabled, iconBefore: (_a = renderIconBefore === null || renderIconBefore === void 0 ? void 0 : renderIconBefore({ isActive })) !== null && _a !== void 0 ? _a : null, iconAfter: (_b = renderIconAfter === null || renderIconAfter === void 0 ? void 0 : renderIconAfter({ isActive })) !== null && _b !== void 0 ? _b : null, error: error, size: size, onClick: onClick, onMouseDown: (e) => {
                    button.onMouseDown(e);
                    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                }, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-FilterSelector', className) }), valueText));
        },
        renderPopover: ({ actions, popover }) => (react_1.default.createElement(FilterMenu_1.FilterMenu, Object.assign({}, popover), renderMenu({ deactivate: actions.hide })))
    });
    return control;
});
//# sourceMappingURL=FilterSelector.js.map